import { CONTACT_LABELS, FORM_FIELDS } from './sharedCopy';

export const FAQ_REACH_US = {
  intro:
    'You are welcome to visit our office in Al Buhairah, Al Khobar. The full address, Google Maps location, and directions are on our Contact page.',
  officeLabel: 'Office:',
  mapLabel: 'Map:',
  mapLink: 'View location on the website',
  emailLabel: 'Email:',
  phoneLabel: 'Phone:',
  whatsappLabel: 'WhatsApp:',
  hoursLabel: 'Hours:',
};

export const HOME_PAGE = {
  whatWeDo: 'What We Do',
  servicesTitleLine1: 'Develop comprehensive solutions',
  servicesTitleLine2: 'for each project',
  readMore: CONTACT_LABELS.readMore,
  numberTalks: 'Number talks',
  counterTitleLine1: 'Part of Al Dawood Holding Group',
  counterTitleLine2: 'since 1998',
  counterDesc:
    'Q-Tech draws on the strength of Al Dawood Holding Group — delivering high-quality construction and trading projects across the private and government sectors throughout Saudi Arabia.',
  contactNow: CONTACT_LABELS.contactNow,
  yourBenefit: 'Your Benefit',
  benefitTitleLine1: 'Trusted delivery across',
  benefitTitleLine2: "Saudi Arabia's Eastern Province",
  whyChooseUs: 'Why Choose Us',
  whyTitleLine1: 'Why choose Q-Tech as your',
  whyTitleLine2: 'contracting partner in Saudi Arabia.',
  whyDesc:
    'Q-Tech Contracting is a Saudi general contractor delivering civil, mechanical, electrical, and industrial construction across Al Khobar, Dammam, Jubail, Yanbu, and the Kingdom — with HSE leadership, on-time delivery, and Al Dawood Holding Group backing since 1998.',
  bestSustainability: 'Best sustainability',
  healthSafety: 'Health and safety',
  modernMethods: 'Modern methods',
  certifiedEngineer: 'Certified engineer',
  workingSkill: 'Working skill',
  clientRating: 'Client rating',
  viewResultPrefix: '5.00 Average Based On 50 Rating –',
  moreInfo: 'More information',
  letsTalk: CONTACT_LABELS.letsTalk,
  projectQuestion: CONTACT_LABELS.projectQuestion,
  placeholderName: FORM_FIELDS.name,
  placeholderEmail: FORM_FIELDS.email,
  placeholderPhone: FORM_FIELDS.phone,
  placeholderService: FORM_FIELDS.service,
  placeholderOther: FORM_FIELDS.other,
  placeholderMessage: FORM_FIELDS.message,
  submitNow: FORM_FIELDS.submit,
  officeTitle: CONTACT_LABELS.officeTitle,
  emailUs: CONTACT_LABELS.emailUs,
  callUs: CONTACT_LABELS.callUs,
  workWithUs: CONTACT_LABELS.workWithUs,
  ctaTitle: CONTACT_LABELS.projectQuestion,
  ctaDescLine1:
    'Partner with Q-Tech for civil, mechanical, electrical, and industrial construction',
  ctaDescLine2: 'across the Eastern and Western regions of Saudi Arabia.',
  getStarted: CONTACT_LABELS.getStarted,
};
